import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const ProfileItems = ({ children, className }) => {
  const cn = useClassNames(
    () => ['flex', 'flex-row', 'flex-wrap', 'p-4', 'bg-slate-100', 'rounded', 'mb-6', className],
    [className],
  );
  return (
    <ul data-component="ProfileItems" className={cn}>
      {children}
    </ul>
  );
};

ProfileItems.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default ProfileItems;
